const faqItems = [
  {
    q: '6080影视收费吗？需要注册会员吗？',
    a: '完全免费！6080影视所有综艺节目均免费在线观看，无需注册、无需登录、无需购买会员。打开网站即可直接观看高清综艺，流量消耗与主流视频平台标清模式相当。',
  },
  {
    q: '为什么播放很流畅，真的不缓冲吗？',
    a: '我们采用多线CDN加速和智能预加载技术，在你点击播放前已提前缓存下一段内容。加上高效的视频编码压缩算法，保证99.9%的流畅播放率。建议使用WiFi或4G/5G网络获得最佳体验。',
  },
  {
    q: '综艺节目更新速度快吗？',
    a: '非常快！我们与各大卫视和网络平台保持同步更新，热门综艺通常在播出后30分钟内即可在6080影视上线。部分节目还提供抢先版，比电视播出更早看到精彩内容。',
  },
  {
    q: '支持哪些设备观看？',
    a: '6080影视全面兼容PC、Mac、平板、手机等设备。网页端打开即看，无需安装插件。同时提供iOS和Android移动客户端，支持离线缓存、投屏电视、倍速播放等实用功能。',
  },
  {
    q: '画质怎么样？支持高清和超清吗？',
    a: '我们提供360P至4K多档清晰度选择，默认推荐1080P高清画质。用户可根据自身网络情况自由切换清晰度。所有综艺节目均经过专业转码优化，确保画质清晰、色彩还原度高。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于6080影视，你可能想了解的一切
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl border border-background-300/20 overflow-hidden">
              <div className="p-5">
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-500/15 flex items-center justify-center mt-0.5">
                    <span className="text-xs font-bold text-primary-400">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading font-semibold text-sm text-foreground-200 mb-2">{item.q}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}